import { createAction, createAsyncAction } from "typesafe-actions";
import { Alert } from "@shared/models";
import { AlertFilter, AlertNotificationFilter, PaginatedResponse, WithCallback } from "@shared/interfaces";
import { AlertReadDto, CreateAlertDto, CreateAlertSuccess } from "@containers/Alert/interfaces";
import { SENSOR_SIGNAL_TYPE } from "@shared/constants";
import { AlertNotification } from "@shared/models/AlertNotification";

import { AlertActionTypes } from "./constants";

export const getAlerts = createAsyncAction(
  AlertActionTypes.GET_ALERTS,
  AlertActionTypes.GET_ALERTS_SUCCESS,
  AlertActionTypes.GET_ALERTS_FAILURE,
)<AlertFilter, Alert[], Error>();

export const createAlert = createAsyncAction(
  AlertActionTypes.CREATE_ALERT,
  AlertActionTypes.CREATE_ALERT_SUCCESS,
  AlertActionTypes.CREATE_ALERT_FAILURE,
)<CreateAlertDto, CreateAlertSuccess, Error>();

export const createUserAlert = createAsyncAction(
  AlertActionTypes.CREATE_USER_ALERT,
  AlertActionTypes.CREATE_USER_ALERT_SUCCESS,
  AlertActionTypes.CREATE_USER_ALERT_FAILURE,
)<CreateAlertDto & { id: number }, CreateAlertSuccess, Error>();

export const getAlertNotifications = createAsyncAction(
  AlertActionTypes.GET_ALERT_NOTIFICATIONS,
  AlertActionTypes.GET_ALERT_NOTIFICATIONS_SUCCESS,
  AlertActionTypes.GET_ALERT_NOTIFICATIONS_FAILURE,
)<
  AlertNotificationFilter,
  PaginatedResponse<AlertNotification> & { selector_type?: SENSOR_SIGNAL_TYPE | null },
  Error
>();

export const readAlertNotification = createAsyncAction(
  AlertActionTypes.READ_ALERT_NOTIFICATION,
  AlertActionTypes.READ_ALERT_NOTIFICATION_SUCCESS,
  AlertActionTypes.READ_ALERT_NOTIFICATION_FAILURE,
)<WithCallback<AlertReadDto>, AlertNotification, Error>();

export const setFilter = createAction(AlertActionTypes.SET_FILTER)<AlertNotificationFilter | null>();
